export default __webpack_public_path__ + "static/media/melody_fr.89d9e843.png";